
import { defineComponent, reactive } from 'vue'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { ConfigService } from '@/services/config.service'

export default defineComponent({
  name: 'KantuFooter',
  props: {
    tabIdx: {
      type: Number,
      required: true,
      default: 0
    },
    isAiImageEditor: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  setup() {
    const injector = useReflectiveInjector()
    const config = injector.get(ConfigService as Type<ConfigService>)

    const viewModel = reactive({
      protocolUrl: config.getMemberProtocolLink,
      userProtocolUrl: config?.getUserProtocolLink || '',
      privacyPolicyUrl: config?.getPrivacyPolicyLink || ''
    })

    function openMemberProtocol() {
      window.open(viewModel.protocolUrl)
    }

    function openUserProtocol() {
      window.open(viewModel.userProtocolUrl)
    }

    function openPrivacyPolicy() {
      window.open(viewModel.privacyPolicyUrl)
    }

    return {
      viewModel,
      openMemberProtocol,
      openUserProtocol,
      openPrivacyPolicy
    }
  }
})
